import { t } from '@/lib/i18n';
import styles from './JobsSearchInput.module.css';

interface JobsSearchInputProps {
  value: string;
  onChange: (query: string) => void;
  placeholder: string;
}

export function JobsSearchInput({ value, onChange, placeholder }: JobsSearchInputProps) {
  return (
    <div className={styles.wrap}>
      <span className={styles.searchIcon} aria-hidden>
        🔍
      </span>
      <input
        type="search"
        className={styles.input}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={t('Search templates')}
      />
      {value ? (
        <button
          type="button"
          className={styles.clear}
          onClick={() => onChange('')}
          aria-label={t('Clear search')}
        >
          ×
        </button>
      ) : null}
    </div>
  );
}
